import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { PersonalCalendarRead } from '@ragu-components/ord-types';

const CalendarsList = React.lazy(async () => import('./CalendarsList'));

export const personalCalendarsResource: OrdResourceProps = {
  key: `me/${Resources.calendars}`,
  name: `me/${Resources.calendars}`,
  list: <CalendarsList />,
  options: {},
  recordRepresentation: (record: PersonalCalendarRead): string => record.title,
};
